import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("/rankingScoreView", {params: params});
  },
}



// WEBPACK FOOTER //
// ./src/services/rankingScoreViewService.js